import { FC } from 'react';
import { useTableRow } from '../shared/useTableRow';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import AbrdnSelect from 'components/Generic/Forms/FormFields/AbrdnSelect';
import styles from './MobileTableRow.module.scss';
import { RowComponentProps } from '../shared/types';
import { useI18n } from 'next-localization';

export const MobileTableRow: FC<RowComponentProps> = ({
  row,
  selectedShareClass,
  onShareClassChange,
  onTogglePastPerformance,
  onTogglePredictivePerformance,
}) => {
  const { placeholder, shareClassOptions, showDownloadButton, downloadlink } = useTableRow(
    row,
    selectedShareClass
  );
  const { t } = useI18n();

  return (
    <div
      key={`${row.id}-mobile`}
      className={`${styles.mobileTableCard} p-3 d-flex flex-column w-100`}
    >
      <p className={`${styles.bodyDefault} mb-4`}>{row.name}</p>
      <div className="d-flex flex-column">
        <p className="section-header-small text-grey mb-1">{t('kidShareClass')}</p>
        <AbrdnSelect
          options={shareClassOptions}
          placeholder={placeholder}
          defaultValue={shareClassOptions[selectedShareClass]}
          className={styles.shareSelector}
          onChange={(event) => onShareClassChange(row, event.value)}
          disabled={shareClassOptions.length === 0}
        />
      </div>

      {row.shareclasses.length > 0 && (
        <div className="d-flex justify-content-between w-100 flex-md-row flex-column mt-4">
          <div className="d-flex flex-column mb-4 mb-md-0">
            <p className="section-header-small text-grey">{t('pastPerformance')}</p>
            <button
              type="button"
              className="btn-naked bi-box-arrow-up-right mt-2"
              onClick={() => onTogglePastPerformance(row)}
            />
          </div>
          <div className="d-flex flex-column mb-4 mb-md-0">
            <p className="section-header-small text-grey">{t('scenarioCalculation')}</p>
            <button
              type="button"
              className="btn-naked bi-box-arrow-up-right mt-2"
              onClick={() => onTogglePredictivePerformance(row)}
            />
          </div>
          {showDownloadButton && (
            <div className="d-flex flex-column align-items-start">
              <p className="section-header-small text-grey">{t('kid')}</p>
              <AbrdnButton
                buttonType="primary"
                linkField={downloadlink}
                showExternalIcon={false}
                className="mt-1"
              >
                <span>{t('download')}</span> {/* Replace with proper localization */}
                <em className="bi-download ms-1" aria-hidden="true" />
              </AbrdnButton>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
